import {
	OverviewScore, ReviewScore
} from "@sabyr-dev/mist_core/model/datasource/score";
import {
	ItemView, ListView, ScoreView, SectionView, SettingsView
} from "@sabyr-dev/mist_core/view";
import { BindRecord } from "@sabyr-dev/mist_core/view/frontend/frontend";
import { ChartView } from "@sabyr-dev/mist_core/view/view/chart";
import { PqView, ViewProps } from "@sabyr-dev/mist_core/view/view/view";
import {
	Attempt, Product, Question, Quiz
} from "@sabyr-dev/mist_elibrary/datasource";
import {
	AcademyChartFrontend, AcademyItemFrontend, AcademyListFrontend,
	AcademyScoreFrontend, AcademySectionFrontend, AcademySettingsFrontend
} from "./frontend";
import { AcademyOverviewSummaryTable } from "../lib/overviewsummary";

export class AcademyView extends PqView<Product, Attempt, Quiz, Question> {
	item: AcademyItemView;
	list: AcademyListView;
	settings: AcademySettingsView;
	sections: AcademySectionView;
	scores: AcademyScoreView;
	chart: AcademyChartView;

	constructor(viewProps: ViewProps<Product, Attempt, Quiz, Question>, bindTarget: Node) {
		super(viewProps)
		this.bindTarget = bindTarget;
	}
}

export abstract class AcademyChartView extends ChartView<Product, Attempt, Quiz, Question> {
	frontend: AcademyChartFrontend;

	abstract getOverviewSummaryTable(jQuery: JQueryStatic): AcademyOverviewSummaryTable;
}

export abstract class AcademyItemView extends ItemView<Product, Attempt, Quiz, Question> {
	frontend: AcademyItemFrontend;

	abstract displayTest(url: string): void;
}

export abstract class AcademyListView extends ListView<Product, Attempt, Quiz, Question> {
	frontend: AcademyListFrontend;

	abstract displayLockedQuestions(freeQuestions: number, locked: boolean, baseColor: string): void;

	abstract displayQuestionResult(item: Question, status: 'correct' | 'incorrect' | 'unanswered', time: number): void;
}

export abstract class AcademyScoreView extends ScoreView<Product, Attempt, Quiz, Question> {
	frontend: AcademyScoreFrontend;

	abstract displayReviewScoreTable(scores: ReviewScore[], total: ReviewScore): void;
}

export abstract class AcademySectionView extends SectionView<Product, Attempt, Quiz, Question> {
	frontend: AcademySectionFrontend;

	abstract displayHighScores(scores: OverviewScore<Attempt, Quiz>[]): void;
}

export abstract class AcademySettingsView extends SettingsView<Product, Attempt, Quiz, Question> {
	frontend: AcademySettingsFrontend;

	abstract getBindSaveEmail(): BindRecord;

	abstract getBindPartialResults(): BindRecord;

	abstract getBindRetryEmail(): BindRecord;

	abstract getBindCheckEmail(): BindRecord;

	abstract updateReportEmail(email: string): void;

	abstract displayEmailModal(jQuery: JQueryStatic, count: number): void;

	abstract hideEmailModal(jQuery: JQueryStatic): void;

	abstract displayDoubleOptInModal(jQuery: JQueryStatic, email: string): void;

	abstract displayDoubleOptInUnlock(): void;

	abstract displayDoubleOptInRetry(): void;

	abstract hideDoubleOptInModal(jQuery: JQueryStatic): void;
}

export default AcademyView;
